export const NOTIFICATIONS_REQUEST = "NOTIFICATIONS_REQUEST";
export const NOTIFICATIONS_SUCCESS = "NOTIFICATIONS_SUCCESS";
export const NOTIFICATIONS_ERROR = "NOTIFICATIONS_ERROR";

export const NOTIFICATIONS_SEEN_REQUEST = "NOTIFICATIONS_SEEN_REQUEST";
export const NOTIFICATIONS_SEEN_SUCCESS = "NOTIFICATIONS_SEEN_SUCCESS";
export const NOTIFICATIONS_SEEN_ERROR = "NOTIFICATIONS_SEEN_ERROR";